<template>
	<div class="order-note bg-white pay-success" v-show="loaded">
		<div class="success">
			<img src="/static/img/payicon.png">
			<div class="tip">{{ tips }}</div>
		</div>
		<div class="explain">根据证监会2016年130号令《证券期货投资者适当性管理办法》的要求，在正式开通服务前，还需要您进行以下两项工作，以便我司据此对您进行风险承受能力评估，开展适当性工作。</div>
		<div class="row action-row">
			<div class="ui_cells" :class="hightlightRow">
				<div class="ui_cell" :class="{disabled: has_survey}" @click="toSurvey">
					<div class="cell_hd">填写<span>《投资者风险承受能力问卷》</span></div>
					<div class="cell_ft" v-text="survey_text"></div> 
				</div>
				<div class="ui_cell" :class="{disabled: has_signed}" @click="toSignContract">
					<div class="cell_hd">签订<span>《证券投资咨询服务合同》</span></div>
					<div class="cell_ft" v-text="signed_text"></div> 
				</div>
			</div>
		</div>
		<div class="wram-tip">
			<div class="title">温馨提示</div>
			<div class="content">
			对您在问卷填写及电子合同签订过程所提供的一切信息，本公司承诺严格按照法律法规要求承担保密义务。未获得法定程序授权前，保证不会将您的隐私信息提供、泄漏给任何第三方，或者将相关信息用于违法、不当用途。
			</div>
		</div>
		<div id="jumpFormDiv" class="hidden"></div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
	name: 'OrderPaySuccess',
	data: () => ({
		'order': {},
		'loaded': false,
		'has_survey': false,
		'tips': '',
		'survey_text': '去填写 >',
		'has_signed': false,
		'signed_text': '去签订 >',
		'hightlightRow': 'pgwj'
	}),
	computed: {
		...mapGetters({
			orderInfo: 'getOrder',
			role: 'getRole'
		})
	},
	created () {
		this.order = this.orderInfo
		this.fetchDetail()
	},
	components: {
	},
	mounted: function () {
		this.setPageTitle('继续完成订单')
	},
	methods: {
		toSurvey () {
			this.PostSurvey(this.order, rs => {
				this.has_survey = rs.data.has_survey
				this.has_signed = !this.has_survey || this.order.has_signed
				this.matchText()
				if (this.has_survey === true) {
					this.survey_text = '已填写 >'
					this.hightlightRow = 'dzht'
					this.order.has_survey = true
					this.toast('已匹配到您填写的问卷, 请去签订合同')
				}
			})
		},
		toSignContract () {
			this.SignContract(this.order, rs => {
				this.has_signed = rs.data.has_signed
				this.signed_text = '已签订 >'
				this.hightlightRow = 'dzht'
				this.order.has_signed = true
				this.matchText()
				this.toast(rs.message)
				this.toCompletePage(true)
			})
		},
		matchText () {
			if (this.order.has_survey) {
				this.survey_text = '已填写 >'
				this.hightlightRow = 'dzht'
			}
			if (this.order.has_signed) {
				this.signed_text = '已签订 >'
				this.hightlightRow = 'dzht'
			}
		},
		toCompletePage (flag) {
			if (this.has_survey && flag) {
				this.$router.replace('/orders/complete/' + this.$route.params.id)
			}
		},
		fetchDetail () {
			this.getOrderSimpleDetail(this.$route.params.id, data => {
				this.order = data
				if (this.order.pay_status === 11) {
					this.setPageTitle('查账信息录入中')
					this.tips = '您的查账信息正委托服务助理录入, 请将您的转账凭证发送给您的专属服务助理'
				} else if (this.order.order_status === 33) {
					this.setPageTitle('财务审核中')
					this.tips = '您的查账信息正在核实中'
				} else if (this.order.order_status === 32) {
					this.setPageTitle('问卷填写')
					this.tips = '您还没有填写问卷，请现在填写'
				}
				this.has_survey = this.order.has_survey
				this.has_signed = !this.order.has_survey || this.order.has_signed
				this.matchText()
				this.toCompletePage(this.order.has_signed)
				this.loaded = true
			})
		}
	}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/customer/OrderPaySuccess.vue